export const loadGtag = () => {
  const gTag = document.getElementById("gTag");
  if (gTag) {
    gTag.remove();
  }
  const script = document.createElement("script");
  script.id = "gTag";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GTAG_ID
    }`;
  script.async = true;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", import.meta.env.VITE_GTAG_ID);
  };
  script.onerror = () => {
    console.error("Couldn't load gtag");
  };
  document.head.appendChild(script);
};
